import backendApis from './backendApis'

export default {
  gate: {
    genQrcode: '/api/v1/gate/gen-qrcode',
    qrcodeScanned: '/api/v1/gate/qrcode-scanned',
    queryAdminUser: '/api/v1/gate/get-admin-user',
    bindAdminUser: '/api/v1/gate/bind-admin-user',
    sso: '/api/v1/gate/sso'
  },
  sso: {
    h5callback: '/api/v1/sso/h5-callback',
    checkQrcode: '/api/v1/sso/check-qrcode',
    authQrcode: '/api/v1/sso/auth-qrcode',
    clientCheckQrcode: '/api/v1/sso/client-check-qrcode',
    clientAuthQrcode: '/api/v1/sso/client-auth-qrcode'
  },
  orgAdmin: {
    login: '/api/v1/org-admin/login',
    logout: '/api/v1/org-admin/logout',
    schoolList: '/api/v1/org-admin/school-list',
    modifyPwd: '/api/v1/org-admin/change-password',
    create: '/api/v1/org-admin/save',
    update: '/api/v1/org-admin/save/',
    delete: '/api/v1/org-admin/del/',
    list: '/api/v1/org-admin',
    isExisted: '/api/v1/org-admin/is-existed'
  },
  schoolAdmin: {
    login: '/api/v1/school-admin/login',
    logout: '/api/v1/school-admin/logout',
    modifyPwd: '/api/v1/school-admin/change-password',
    create: '/api/v1/school-admin/save',
    update: '/api/v1/school-admin/save/',
    delete: '/api/v1/school-admin/del/',
    list: '/api/v1/school-admin',
    isExisted: '/api/v1/school-admin/is-existed'
  },
  user: {
    list: '/api/v1/user',
    listByGroup: '/api/v1/user/list-by-groupid',
    detail: '/api/v1/user/detail/',
    create: '/api/v1/user/save',
    modify: '/api/v1/user/save/',
    delete: '/api/v1/user/del/',
    deleteMany: '/api/v1/user/delete-many',
    importExcel: '/api/v1/user/import',
    exportExcel: '/api/v1/user/export',
    listOfSchool: '/api/v1/user/list-by-schoolid',
    statistics: '/api/v1/user/statistics',
    lastEditTime: '/api/v1/user/record-summary/last-edit-time',
    changeEnableState: '/api/v1/user/change-enable-state',
    count: '/api/v1/user/count',
    isExisted: '/api/v1/user/is-number-existed',
    mealCardInfo: '/api/v1/user/meal-card-info',
    changeMealCard: '/api/v1/user/change-meal-card',
    changeIcCard: '/api/v1/user/change-ic-card',
    companyInfo: '/api/v1/user/company-info'
  },
  school: {
    listByOrgId: '/api/v1/school/list-by-orgid',
    schoolName: '/api/v1/school/name-by-code/',
    schoolCode: '/api/v1/school/code-by-name',
    dataCenterUrl: '/api/v1/school/data-center-url'
  },
  organization: {
    orgName: '/api/v1/organization/name-by-code/',
    orgCode: '/api/v1/organization/code-by-name'
  },
  schoolType: {
    list: '/api/v1/school-type'
  },
  studentGroup: {
    create: '/api/v1/student-group/save',
    update: '/api/v1/student-group/save/',
    delete: '/api/v1/student-group/del/',
    list: '/api/v1/student-group',
    count: '/api/v1/student-group/',
    saveMany: '/api/v1/student-group/save-many',
    isExisted: '/api/v1/student-group/is-existed'
  },
  nutrition: {
    classesNutrition: '/api/v1/nutrition/classes',
    studentsNutrition: '/api/v1/nutrition/class-students',
    studentsNutritionExport: '/api/v1/nutrition/students-nutrition-export',
    statistics: '/api/v1/nutrition/statistics',
    relatedPersonnel: '/api/v1/nutrition/related-personnel',
    relatedCanteen: '/api/v1/nutrition/related-canteen',
    mealData: '/api/v1/nutrition/user-meal-data',
    oneClassStatistics: '/api/v1/nutrition/one-class-statistics',
    exportRelatedCanteen: '/api/v1/nutrition/export-related-personnel',
    manualRecordMeal: '/api/v1/nutrition/manual_record_meal'
  },
  supply: {
    list: '/api/v1/supply/list',
    exportExcel: '/api/v1/supply/export',
    importExcel: '/api/v1/supply/import'
  },
  dailyFoodMenu: {
    list: '/api/v1/daily-food-menu',
    detail: '/api/v1/daily-food-menu/',
    auto: '/api/v1/daily-food-menu/auto',
    exportAuto: '/api/v1/daily-food-menu/export-auto',
    save: '/api/v1/daily-food-menu/save',
    delete: '/api/v1/daily-food-menu/del/',
    runNow: '/api/v1/daily-food-menu/run-now',
    importExcel: '/api/v1/daily-food-menu/batch-import',
    importAutoExcel: '/api/v1/daily-food-menu/auto-import',
    updateNextIndex: '/api/v1/daily-food-menu/update-next-index'
  },
  file: {
    static: '/api/v1/file/static/',
    runtime: '/api/v1/file/runtime/'
  },
  backend: backendApis
}
